import { render } from "./IframeBackground.vue?vue&type=template&id=49f77132"
import script from "./IframeBackground.vue?vue&type=script&lang=js"
export * from "./IframeBackground.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__